module.exports = __webpack_public_path__ + "static/img/default-shop-logo.890476d7.png";